module.exports = __webpack_public_path__ + "static/media/rp.1a2cafb6.svg";